import { useState, useEffect, useRef } from 'react';
import {
    Container,
    Header,
    Icon,
    Options,
    Content,
    Footer
} from './styled';
import { TabList } from './TabList';
import {
    Search,
    Modal,
    NewChat,
    ContactsList,
    ShootingMessage,
    TransmissionList
} from '../../../components';
import { IoEllipsisVertical, IoClose } from 'react-icons/io5';
import { BiMailSend } from 'react-icons/bi';
import { RiContactsBook2Line } from 'react-icons/ri';
import { GoCommentDiscussion } from 'react-icons/go';
import { TbUsers } from "react-icons/tb";
import neuron from '../../../assets/SVGs/neuron.svg';
import { useChat } from '../../../contexts/chat';

export function List() {

    const { version: appVersion } = require('../../../../package.json');
    const [openMenu, setOpenMenu] = useState(false);
    const [menuItem, setMenuItem] = useState({ title: '', component: -1 });
    const {
        textSearch,
        setTextSearch,
        loadingAccessLevel,
        accessLevel,
        orderList,
        SelectOrderList
    } = useChat();
    const menuRef = useRef(null);

    function handleLink() {
        window.open("https://neurondata.com.br/", '_blank');
    };
    function handleOnClick(menuSelected) {
        setOpenMenu(false);
        setMenuItem(menuSelected);
    };

    useEffect(() => {
        function handleClickOutside(event) {
          if (menuRef.current && !menuRef.current.contains(event.target)) {
            setOpenMenu(false);
          }
        }
    
        if (openMenu) {
          document.addEventListener('mousedown', handleClickOutside);
        } else {
          document.removeEventListener('mousedown', handleClickOutside);
        }
    
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, [openMenu]);

    return (
        <>
            <Container>
                <Header>
                    <Icon>
                        {!openMenu
                            ? <IoEllipsisVertical
                                className='icon--'
                                onClick={() => setOpenMenu(!openMenu)}
                            />
                            : <IoClose
                                className='icon--close'
                                onClick={() => setOpenMenu(!openMenu)}
                            />
                        }
                    </Icon>
                    <Search
                        value={textSearch}
                        onChange={(e) => setTextSearch(e.target.value)}
                    />
                </Header>
                <Options ref={menuRef} menuOpen={openMenu}>
                    <li onClick={() => handleOnClick({ title: 'Nova Conversa', component: 0 })}>
                        <GoCommentDiscussion className='icon--menu' />
                        {`Nova Conversa`}
                    </li>
                    <li onClick={() => handleOnClick({ title: 'Contatos', component: 2 })}>
                        <TbUsers className='icon--menu' />
                        {`Contatos`}
                    </li>
                    <li onClick={() => handleOnClick({ title: 'Lista de Transmissão', component: 3 })}>
                        <RiContactsBook2Line className='icon--menu' />
                        {`Lista de Transmissão`}
                    </li>
                    {accessLevel?.includes('SEND_LIST') &&
                        <li onClick={() => handleOnClick({ title: 'Disparar Mensagem', component: 1 })}>
                            <BiMailSend className='icon--menu' />
                            {`Disparar Mensagem`}
                        </li>
                    }
                </Options>
                <Content>
                    <TabList
                        loadingAccessLevel={loadingAccessLevel}
                        accessLevel={accessLevel}
                        orderList={orderList}
                        SelectOrderList={SelectOrderList}
                    />
                </Content>
                <Footer>
                    <img
                        src={neuron}
                        onClick={() => handleLink()}
                        alt="neuron - COPYRIGHT"
                    />
                    <span></span>
                    <span>
                        <span className='copyright'>
                            &#169;
                        </span>
                        {`${new Date().getFullYear()} - v${appVersion}`}
                    </span>
                </Footer>
            </Container>
            <Modal
                title={menuItem?.title}
                isOpen={menuItem?.component !== -1 ? 1 : 0}
                close={() => setMenuItem({ title: '', component: -1 })}
            >
                {menuItem?.component === 0 &&
                    <NewChat
                        close={() => setMenuItem({ title: '', component: -1 })}
                    />
                }
                {menuItem?.component === 1 && accessLevel?.includes('SEND_LIST') &&
                    <ShootingMessage
                        alowCreateList={accessLevel.includes('CREATE_LIST')}
                    />
                }
                {menuItem?.component === 2 &&
                    <ContactsList
                        back={() => setMenuItem({ title: '', component: -1 })}
                        source={'List'}
                    />
                }
                {menuItem?.component === 3 &&
                    <TransmissionList
                        back={false}
                        alowCreateList={accessLevel.includes('CREATE_LIST')}
                    />
                }
            </Modal>
        </>
    );
}   